import { useApi } from '@omnipresentgroup/api';
import type { IsoDate } from '@omnipresentgroup/design-system';
import { useCallback } from 'react';

import { API_BASE, API_PATH } from '../constants';

export const useTimeOffsUpload = () => {
  const { POST } = useApi();
  const uploadTimeOffsFile = useCallback(
    ({ file, date }: { file: File; date: IsoDate }) => {
      return POST({
        path: `${API_BASE}/${API_PATH}/upload`,
        body: { file, year_month: date },
        asFormData: true,
      });
    },
    [POST],
  );

  return {
    uploadTimeOffsFile,
  };
};
